module.exports = __webpack_public_path__ + "img/spread_profile_example_super_search.53c8332a.jpg";